import { CandidateMatchComponentTypeDto } from '@/api/generated';
import {
  confirmDialogTranslation,
  ConfirmDialogTranslation,
} from '@/assets/locales/components/confirmDialog/confirmDialog.translation.en.ts';
import {
  fallbackUiTranslation,
  FallbackUiTranslation,
} from '@/assets/locales/components/falbackUi/fallbackUi.translation.en.ts';
import {
  componentsFormTranslation,
  ComponentsFormTranslation,
} from '@/assets/locales/components/form/components.form.translation.en.ts';
import {
  infoDialogTranslation,
  InfoDialogTranslation,
} from '@/assets/locales/components/infoDialog/infoDialog.translation.en.ts';
import {
  VersionCheckerTranslations,
  versionCheckerTranslations,
} from '@/assets/locales/components/versionChecker/versionChecker.translations.en.ts';

import { tableTranslations, TableTranslations } from './table/table.translations.en';

export type ComponentsTranslation = {
  aiGenerated: {
    tooltip: string;
  };
  confirmDialog: ConfirmDialogTranslation;
  fallbackUi: FallbackUiTranslation;
  form: ComponentsFormTranslation;
  infoDialog: InfoDialogTranslation;
  match: string;
  matchScore: {
    componentMatch: Record<CandidateMatchComponentTypeDto, string>;
    legendTitle: string;
  };
  searchChip: {
    actions: {
      cancel: string;
      edit: string;
      remove: string;
      save: string;
    };
    inputPlaceholder: string;
  };
  table: TableTranslations;
  versionChecker: VersionCheckerTranslations;
};

export const componentsTranslation: ComponentsTranslation = {
  aiGenerated: {
    tooltip: 'Content generated by AI',
  },
  confirmDialog: confirmDialogTranslation,
  fallbackUi: fallbackUiTranslation,
  form: componentsFormTranslation,
  infoDialog: infoDialogTranslation,
  match: 'Match',
  matchScore: {
    componentMatch: {
      [CandidateMatchComponentTypeDto.CompanyLoyalty]: 'Loyalty',
      [CandidateMatchComponentTypeDto.IndustryExperience]: 'Preferable industry experience',
      [CandidateMatchComponentTypeDto.MainAnalysis]: 'Main analysis',
    },
    legendTitle: 'Match components',
  },
  searchChip: {
    actions: {
      cancel: 'Cancel',
      edit: 'Edit',
      remove: 'Remove',
      save: 'Save',
    },
    inputPlaceholder: 'Enter CV Search requirement...',
  },
  table: tableTranslations,
  versionChecker: versionCheckerTranslations,
};
